import type { IconSvgObject } from './types';

const SwipeLeft04Icon: IconSvgObject = [
  ["path", { d: "M6.5 15L6.5 11M6.5 11L6.5 4.75C6.5 3.7835 7.2835 3 8.25 3C9.2165 3 10 3.7835 10 4.75L10 11H14.5C16.1569 11 17.5 12.3431 17.5 14V19C17.5 20.6569 16.1569 22 14.5 22H8.0841C7.40785 22 6.77739 21.6583 6.40829 21.0916L4.48731 18.1426C3.61571 16.8152 3.51657 16.2011 3.50083 15.5302C3.49373 15.2276 3.53246 14.9256 3.61571 14.6346C3.80031 13.9894 4.27679 13.4448 5.2297 12.3558L6.5 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 4.5L17 2M14.5 4.5L17 7M14.5 4.5L20.5 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SwipeLeft04Icon;
